// src/features/projects/components/ProjectFooterCTA.tsx
import React, { useState } from 'react';
import styles from './ProjectFooterCTA.module.scss';
import { NavLink } from 'react-router-dom';

interface CallToAction {
  hasPublicDemo: boolean;
  demoUrl?: string;
  contactMeUrl: string;
  footerText: string;
  footerLinkTextPublic: string;
  footerLinkTextConfidential: string;
  modalTitle?: string;
  modalDescription?: string;
  modalContactButton?: string;
  modalCloseButton?: string;
}

interface ProjectFooterCTAProps {
  callToAction: CallToAction;
}

const ProjectFooterCTA: React.FC<ProjectFooterCTAProps> = ({ callToAction }) => {
  const [showModal, setShowModal] = useState(false);

  const handleLinkClick = () => {
    if (callToAction.hasPublicDemo && callToAction.demoUrl) {
      window.open(callToAction.demoUrl, '_blank');
    } else {
      setShowModal(true);
    }
  };

  const handleCloseModal = () => setShowModal(false);

  return (
    <footer className={styles.ctaFooter}>
      <p className={styles.footerText}>
        {callToAction.footerText}
        {' '}
        <button className={styles.linkButton} onClick={handleLinkClick}>
          {callToAction.hasPublicDemo 
            ? callToAction.footerLinkTextPublic
            : callToAction.footerLinkTextConfidential}
        </button>
      </p>

      {showModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <h3>{callToAction.modalTitle || "Confidential Project"}</h3>
            <p>{callToAction.modalDescription || "This project is protected by an NDA. For more details, feel free to contact me directly!"}</p>
            <div className={styles.modalActions}>
              <NavLink className={styles.ctaButton} to="/contact">
                {callToAction.modalContactButton || "Contact Me"}
              </NavLink>
              <button className={styles.closeButton} onClick={handleCloseModal}>
                {callToAction.modalCloseButton || "Close"}
              </button>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
};

export default ProjectFooterCTA;